import { makeStyles,fade } from "@material-ui/core/styles";
import { BorderRight } from "@material-ui/icons";
const useStyles = makeStyles(theme => ({
  pageContentDIvTrip: {
    padding: 24,
    paddingTop: 0,
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  divFilter:{
    width:'100%',
    backgroundColor:'#fff',
    padding:'22px 24px',
    borderBottom:'1px solid #dfe2e5'
  },
  divSparkline:{
    width:'100%',
    backgroundColor:'#fff',
    padding:24,
  },
  topGrid:{
    borderRadius:4
  },
  emptyStateBox:{
    width:'100%',
    padding:'48px 64px',
    backgroundColor:'#fff',
    borderRadius:4,
    //height:'calc(100vh - 412px)'
  },
  emptyStateIcon:{
    fontSize:162,
    marginBottom:4
  },
  emptyStateTitle:{
    fontSize:16,
    fontWeight:600,
    color:'#0a142a',
    marginBottom:4
  },
  emptyStateSubTitle:{
    fontSize:12,
    color:'#0a142a',
    marginBottom:24,
    textAlign:'center'
  },
  emptyStateCta: {
      borderRadius: 4,
      border: 0,
      color: 'white',
      fontWeight:600,
      padding: '12px 29px',
      textTransform: 'capitalize',
      '&:hover': {
          backgroundColor: '#0033cc'
      },
      fontWeight: 'normal',
  },
  listStateCta: {
      borderRadius: 4,
      border: 0,
      color: 'white',
      fontWeight:600,
      padding: '4px 12px',
      textTransform: 'capitalize',
      '&:hover': {
          backgroundColor: '#0033cc'
      },
      fontWeight: 'normal',
  },
  listStateBox:{
    padding: '16px 16px 24px',
    width:'100%',
    backgroundColor:'#fff',
    borderRadius:4,
  },
  headerTitle:{
    fontSize:16,
    fontWeight:600,
    color:'#0b1323',
    marginLeft:16
  },
  headerIcon:{
    fontSize:20
  },
  headerBox:{
    width:'100%'
  },
  iconBox:{
    padding:6,
    borderRadius:'50%'
  },
  listIconBox:{
    padding:4,
    borderRadius: 8,
    backgroundColor:' #f1f1f3',
    marginRight:8
  },
  listBox:{
    marginTop:16,
    height:'calc(100vh - 412px)',
    overflow:'auto',
    paddingRight:1
  },
  listValueAmount:{
    fontSize:12,
    fontWeight:600,
    color:'#0b1323'
  },
  listValueName:{
    fontSize:12,
    fontWeight:600,
    color:'#0b1323'
  },
  expBox:{
    padding:' 12px 16px',
    borderRadius: 8,
    boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    cursor:'pointer'
  },
  expDate:{
    fontSize:10,
    color:'#656565'
  },
  expBullet:{
    fontSize:5,
    margin:'0px 8px',
    color:'#2c5de5'
  },
  expTruckNumber:{
    fontSize:10,
    color:'#1a1a1a'
  },
  expRoute:{
    fontSize:10,
    color:'#1a1a1a'
  },
  expActionBox:{
    padding: '12px 12px 12px 16px',
    borderRadius: 4,
    border: 'solid 1px #dfe2e5',
    backgroundColor: '#fff',
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    borderRadius: 4,
    backgroundColor: "rgba(241, 241, 243, 0.5)",
    '&:hover': {
      backgroundColor: 'rgba(241, 241, 243, 0.5)',
    },
    //border: "solid 1px rgba(11, 19, 35, 0.5)",
    marginRight: 0,
    marginLeft: 0,
    marginTop:24,
    width: '100%',
  },
  sicon: {
    fontSize: 18
  },
  searchIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    fontSize: 14,
    padding: "9px 0px",
    color:'rgba(11, 19, 35, 0.75)',
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    width: '100%'
  },
  headerLabel:{
    fontSize:12,
    color:'rgba(11, 19, 35, 0.75)'
  },
  headerAmount:{
    fontSize:16,
    fontWeight:600,
    color:'#0b1323'
  },
  expenseDescription:{
    fontSize:10,
    fontStyle:'italic',
    color: 'rgba(11, 19, 35, 0.75)'
  }
}));
export default useStyles;